webpackJsonp([1],{

/***/ "+DEH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/Pi3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "08S2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1TdX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3__ = __webpack_require__("vwbq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_mixins_roll__ = __webpack_require__("8X7C");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_widgets_CompGraph__ = __webpack_require__("x9ei");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






// byName is a comparison function for Array.sort that puts the array in
// alphabetical order, other than the name 'Other' which is always last.
function byName(a, b) {
  if (a.name == 'Other') {
    return 1;
  } else if (b.name == 'Other') {
    return -1;
  } else if (a.name < b.name) {
    return -1;
  } else if (a.name > b.name) {
    return 1;
  }
  return 0;
}
// byOrganization is a comparison function for Array.sort that puts names into
// pre-sorted buckets depending on the organization name that's present.
function byOrganization(a, b) {
  var orgs = ['Google', 'DigiCert', 'Let\'s Encrypt', 'Sectigo', 'Cloudflare'];

  var aIdx = orgs.length,
      bIdx = orgs.length;
  for (var i = 0; i < orgs.length; i++) {
    if (a.name.includes(orgs[i])) {
      aIdx = i;
    }
    if (b.name.includes(orgs[i])) {
      bIdx = i;
    }
  }

  if (aIdx < bIdx) {
    return -1;
  } else if (aIdx > bIdx) {
    return 1;
  }
  return byName(a, b);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'UtilGraph',
  props: {
    data: { type: Array, required: true }
  },
  data: function data() {
    var googleColors = __WEBPACK_IMPORTED_MODULE_0_d3__["j" /* scaleOrdinal */](['#dadaeb', '#bcbddc', '#9e9ac8', '#807dba', '#6a51a3', '#4a1486']);
    var caColors = __WEBPACK_IMPORTED_MODULE_0_d3__["j" /* scaleOrdinal */](['#fdae6b', '#fd8d3c', '#f16913', '#d94801', '#a63603']);
    var otherColors = __WEBPACK_IMPORTED_MODULE_0_d3__["j" /* scaleOrdinal */](['#66c2a4', '#41ae76', '#238b45', '#006d2c', '#00441b']);

    return {
      palette: function palette(name) {
        if (name.includes('Google')) {
          return googleColors(name);
        } else if (name.includes('DigiCert') || name.includes('Let\'s Encrypt') || name.includes('Sectigo')) {
          return caColors(name);
        }
        return otherColors(name);
      }
    };
  },
  computed: {
    organizations: function organizations() {
      return this.data.map(function (d) {
        return { name: d.Name, data: __WEBPACK_IMPORTED_MODULE_1__components_mixins_roll__["a" /* itemize */](d.Data).sort(byOrganization) };
      }).sort(byName);
    },
    logs: function logs() {
      var acc = this.organizations.reduce(function (acc, org) {
        for (var i = 0; i < org.data.length; i++) {
          var name = org.data[i].name,
              count = org.data[i].count;
          if (name in acc) {
            acc[name] += count;
          } else {
            acc[name] = count;
          }
        }
        return acc;
      }, {});

      var out = [];
      for (var name in acc) {
        out.push({ name: name, count: acc[name] });
      }
      return out.sort(byOrganization).filter(function (x) {
        return x.name != 'Other';
      });
    }
  },
  components: { CompGraph: __WEBPACK_IMPORTED_MODULE_2__components_widgets_CompGraph__["a" /* default */] }
});

/***/ }),

/***/ "2+Bm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Octicon_vue__ = __webpack_require__("WeE0");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_da982288_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Octicon_vue__ = __webpack_require__("2Q+v");
function injectStyle (ssrContext) {
  __webpack_require__("8kLh")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Octicon_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_da982288_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Octicon_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2Q+v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{class:_vm.clazz,style:(_vm.style),attrs:{"version":"1.1","role":_vm.label ? 'img' : 'presentation',"aria-label":_vm.label,"x":_vm.x,"y":_vm.y,"width":_vm.width,"height":_vm.height,"viewBox":_vm.box}},[_vm._t("default",[(_vm.icon)?_c('path',{attrs:{"d":_vm.icon.d}}):_vm._e()])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "2bLC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3h0Q":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4ZOf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.error)?_c('Errorpage',{attrs:{"msg":_vm.error}}):_vm._e(),_vm._v(" "),(!_vm.log && !_vm.error)?_c('NotFound'):_vm._e(),_vm._v(" "),(_vm.log)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4 log-details"},[_c('h6',[_vm._v("Log Details")]),_vm._v(" "),_c('h4',[_vm._v(_vm._s(_vm.log.Name))]),_vm._v(" "),_c('p',[(_vm.log.Endpoint == '(Private Log)')?_c('span',[_vm._v(_vm._s(_vm.log.Endpoint))]):_c('a',{attrs:{"href":'https://'+_vm.log.Endpoint}},[_vm._v(_vm._s(_vm.log.Endpoint))]),_c('br'),_vm._v(" "),_c('span',[_c('u',[_vm._v("Last Update:")]),_vm._v(" "+_vm._s(_vm.sprintDate(_vm.log.LastUpdate)))]),_c('br'),_vm._v(" "),_c('span',[_c('u',[_vm._v("Avg. Throughput:")]),_vm._v(" "+_vm._s(_vm.throughput.toLocaleString())+" cert"),(_vm.throughput != 1)?[_vm._v("s")]:_vm._e(),_vm._v("/hr")],2),_c('br'),_vm._v(" "),_c('span',[_c('u',[_vm._v("Contains:")]),_vm._v(" "+_vm._s(_vm.log.Count.toLocaleString())+" certificate"),(_vm.log.Count != 1)?[_vm._v("s")]:_vm._e()],2),_c('br'),_vm._v(" "),_c('span',[_c('u',[_vm._v("Unsubmitted:")]),_vm._v(" "+_vm._s(_vm.log.Unsubmitted.toLocaleString())+" certificate"),(_vm.log.Unsubmitted != 1)?[_vm._v("s")]:_vm._e(),_vm._v(" ("+_vm._s(_vm.sprintSmallPercent(_vm.log.Count / (_vm.log.Count + _vm.log.Unsubmitted)))+" full)")],2)]),(_vm.atCapacity && _vm.velocity.length > 0)?_c('p',[_vm._v("This log is operating at full capacity.")]):_vm._e(),_vm._v(" "),(_vm.velocity.length == 0)?_c('p',[_c('strong',[_vm._v("This log is frozen.")]),_vm._v(" It\n        accepts no new entries and signs no new STHs but continues to operate\n        in read-only mode.")]):_vm._e(),_vm._v(" "),_c('h6',{staticClass:"sub-header"},[_vm._v("Uptime")]),_vm._v(" "),_c('h5',[_vm._v(_vm._s(_vm.sprintPercent(_vm.log.Profile.Uptime)))]),_vm._v(" "),_c('table',{staticClass:"table table-sm table-hover"},[_vm._m(0),_vm._v(" "),_c('tbody',_vm._l((_vm.endpoints),function(ep){return _c('tr',[_c('td',[_vm._v(_vm._s(ep.name))]),_vm._v(" "),(_vm.log.Profile.ByEndpoint[ep.tag].Uptime == -1)?_c('td',{staticClass:"text-right"},[_vm._v("N/A")]):_vm._e(),_vm._v(" "),(_vm.log.Profile.ByEndpoint[ep.tag].Uptime != -1)?_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.sprintPercent(_vm.log.Profile.ByEndpoint[ep.tag].Uptime)))]):_vm._e()])}),0)]),_vm._v(" "),_c('h6',{staticClass:"sub-header"},[_vm._v("Response Time")]),_vm._v(" "),_c('h5',[_vm._v(_vm._s(_vm.sprintDuration(_vm.log.Profile.ResponseTime)))]),_vm._v(" "),_c('table',{staticClass:"table table-sm table-hover"},[_vm._m(1),_vm._v(" "),_c('tbody',_vm._l((_vm.endpoints),function(ep){return _c('tr',[_c('td',[_vm._v(_vm._s(ep.name))]),_vm._v(" "),(_vm.log.Profile.ByEndpoint[ep.tag].ResponseTime == -1)?_c('td',{staticClass:"text-right"},[_vm._v("N/A")]):_vm._e(),_vm._v(" "),(_vm.log.Profile.ByEndpoint[ep.tag].ResponseTime != -1)?_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.sprintDuration(_vm.log.Profile.ByEndpoint[ep.tag].ResponseTime)))]):_vm._e()])}),0)])]),_vm._v(" "),_c('div',{staticClass:"col-md-8 log-graphs"},[(_vm.velocity.length > 0)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('h6',[_vm._v("Log Velocity")]),_vm._v(" "),_c('VelocityGraph',{attrs:{"id":"velocity","data":_vm.velocity}}),_vm._v(" "),_c('h6',{staticClass:"sub-header"},[_vm._v("Certificates Seen vs. Tree Growth")])],1)]):_vm._e(),_vm._v(" "),_c('h6',[_vm._v("Contents Breakdown")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('Filters',{attrs:{"breakdownFilters":_vm.breakdownFilters,"unselect":_vm.unselect}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('PieGraph',{attrs:{"id":"vallevel","data":_vm.breakdown['valLevel'],"select":_vm.select('valLevel')}}),_vm._v(" "),_c('h6',{staticClass:"sub-header"},[_vm._v("Validation Level")])],1),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('PieGraph',{attrs:{"id":"pubalg","data":_vm.breakdown['pubAlg'],"select":_vm.select('pubAlg')}}),_vm._v(" "),_c('h6',{staticClass:"sub-header"},[_vm._v("Public Key Algorithm")])],1),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('PieGraph',{attrs:{"id":"sigalg","data":_vm.breakdown['sigAlg'],"select":_vm.select('sigAlg')}}),_vm._v(" "),_c('h6',{staticClass:"sub-header"},[_vm._v("Signature Algorithm")])],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-2"},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('PieGraph',{attrs:{"id":"entrytype","data":_vm.breakdown['entryType'],"select":_vm.select('entryType')}}),_vm._v(" "),_c('h6',{staticClass:"sub-header"},[_vm._v("Entry Type")])],1),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('PieGraph',{attrs:{"id":"expired","data":_vm.breakdown['expired'],"select":_vm.select('expired')}}),_vm._v(" "),_c('h6',{staticClass:"sub-header"},[_vm._v("Expired vs. Current")])],1),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_vm._v(" ")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('CompGraph',{attrs:{"id":"root","data":_vm.breakdown['rootName'],"select":_vm.select('rootName')}}),_vm._v(" "),_c('h6',{staticClass:"sub-header"},[_vm._v("Root Certificate Authorities")])],1)])])]):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticClass:"sr-only"},[_c('tr',[_c('th',{attrs:{"scope":"col"}},[_vm._v("Endpoint")]),_vm._v(" "),_c('th',{staticClass:"text-right",attrs:{"scope":"col"}},[_vm._v("Uptime")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticClass:"sr-only"},[_c('tr',[_c('th',{attrs:{"scope":"col"}},[_vm._v("Endpoint")]),_vm._v(" "),_c('th',{staticClass:"text-right",attrs:{"scope":"col"}},[_vm._v("Resp. Time")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "55vb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IssuanceGraph_vue__ = __webpack_require__("N+nW");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f07dd7a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IssuanceGraph_vue__ = __webpack_require__("Ccha");
function injectStyle (ssrContext) {
  __webpack_require__("jME9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1f07dd7a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IssuanceGraph_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f07dd7a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IssuanceGraph_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5BEz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"frontpage"},[(_vm.error)?_c('Errorpage',{attrs:{"msg":_vm.error}}):_vm._e(),_vm._v(" "),(!_vm.error && _vm.data)?[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-8 global-graphs"},[_c('h6',[_vm._v("Certificate Breakdown by Type")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('Filters',{attrs:{"breakdownFilters":_vm.breakdownFilters,"unselect":_vm.unselect}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('PieGraph',{attrs:{"id":"vallevel","data":_vm.breakdown['valLevel'],"select":_vm.select('valLevel')}}),_vm._v(" "),_c('h6',{staticClass:"sub-header"},[_vm._v("Validation Level")])],1),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('PieGraph',{attrs:{"id":"pubalg","data":_vm.breakdown['pubAlg'],"select":_vm.select('pubAlg')}}),_vm._v(" "),_c('h6',{staticClass:"sub-header"},[_vm._v("Public Key Algorithm")])],1),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('PieGraph',{attrs:{"id":"sigalg","data":_vm.breakdown['sigAlg'],"select":_vm.select('sigAlg')}}),_vm._v(" "),_c('h6',{staticClass:"sub-header"},[_vm._v("Signature Algorithm")])],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-2"},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('PieGraph',{attrs:{"id":"entrytype","data":_vm.breakdown['entryType'],"select":_vm.select('entryType')}}),_vm._v(" "),_c('h6',{staticClass:"sub-header"},[_vm._v("Entry Type")])],1),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('PieGraph',{attrs:{"id":"expired","data":_vm.breakdown['expired'],"select":_vm.select('expired')}}),_vm._v(" "),_c('h6',{staticClass:"sub-header"},[_vm._v("Expired vs. Current")])],1),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_vm._v(" ")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('CompGraph',{attrs:{"id":"root","data":_vm.breakdown['rootName'],"select":_vm.select('rootName')}}),_vm._v(" "),_c('h6',{staticClass:"sub-header"},[_vm._v("Root Certificate Authorities")])],1)])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('h6',[_vm._v("Global Details")]),_vm._v(" "),_c('p',[_c('span',[_c('u',[_vm._v("Issuance Rate:")]),_vm._v(" "+_vm._s(_vm.data.Details.IssuanceRate.toLocaleString())+" certs/hr")]),_c('br'),_vm._v(" "),_c('span',[_c('u',[_vm._v("Expiry Rate:")]),_vm._v(" "+_vm._s(_vm.data.Details.ExpiryRate.toLocaleString())+" certs/hr")]),_c('br')]),_vm._v(" "),_c('h6',[_vm._v("Legacy Algorithms")]),_vm._v(" "),_c('p',[_vm._v("The tables below count the number of currently-valid certificates\n        signed by widely trusted CAs that use insecure or deprecated\n        algorithms.")]),_vm._v(" "),_c('table',{staticClass:"table table-sm table-hover"},[_vm._m(0),_vm._v(" "),_c('tbody',[_vm._l((_vm.legacySigAlgs),function(alg){return _c('tr',[_c('td',[_vm._v(_vm._s(alg.name))]),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(alg.count.toLocaleString()))])])}),_vm._v(" "),(_vm.legacySigAlgs.length == 0)?_c('tr',[_vm._m(1)]):_vm._e()],2)]),_vm._v(" "),_c('table',{staticClass:"table table-sm table-hover"},[_vm._m(2),_vm._v(" "),_c('tbody',[_vm._l((_vm.legacyPubAlgs),function(alg){return _c('tr',[_c('td',[_vm._v(_vm._s(alg.name))]),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(alg.count.toLocaleString()))])])}),_vm._v(" "),(_vm.legacyPubAlgs.length == 0)?_c('tr',[_vm._m(3)]):_vm._e()],2)])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('h6',[_vm._v("Issuance per Day by Certificate Authority")]),_vm._v(" "),_c('IssuanceGraph',{attrs:{"id":"global","data":_vm.data.Issuance}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('h6',[_vm._v("Log Utilization by Large Certificate Authorities")]),_vm._v(" "),_c('p',[_vm._v("This section shows the number of pre-certificates in known CT logs\n        from a few particularly large certificate authorities. Anyone can\n        submit a pre-certificate they find in one log to another log, but this\n        currently shows that some CAs have a clear preference for certain CT\n        logs when they issue a certificate containing embedded SCTs, while\n        others submit to several logs equally.")]),_vm._v(" "),_c('UtilGraph',{attrs:{"data":_vm.data.Utilization}})],1)])]:_vm._e()],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{attrs:{"scope":"col"}},[_vm._v("Signature Algorithm")]),_vm._v(" "),_c('th',{staticClass:"text-right",attrs:{"scope":"col"}},[_vm._v("#")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{attrs:{"colspan":"2"}},[_c('em',[_vm._v("(None)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{attrs:{"scope":"col"}},[_vm._v("Public-Key Algorithm")]),_vm._v(" "),_c('th',{staticClass:"text-right",attrs:{"scope":"col"}},[_vm._v("#")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{attrs:{"colspan":"2"}},[_c('em',[_vm._v("(None)")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7Dgi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"id":'pie-chart-'+_vm.id,"viewBox":"0,0,250,250","preserveAspectRatio":"xMaxYMax meet"}},[_c('g',{attrs:{"transform":"translate(125, 125)"}},[_c('circle',{attrs:{"r":"125","fill":"#e5e5e5"}}),_vm._v(" "),_c('g',{staticClass:"tooltipg",attrs:{"transform":"translate(-500, -500)"}},[_c('circle',{attrs:{"r":"80","fill":"white"}}),_vm._v(" "),_c('circle',{staticClass:"body",attrs:{"r":"77"}}),_vm._v(" "),_c('text',{attrs:{"fill":"white","text-anchor":"middle"}},[_c('tspan',{staticClass:"name",attrs:{"x":"0","dy":"-0.5em"}}),_vm._v(" "),_c('tspan',{staticClass:"count",attrs:{"x":"0","dy":"1.25em"}}),_vm._v(" "),_c('tspan',{staticClass:"percent",attrs:{"x":"0","dy":"1.25em"}})])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7O1K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('nav',{staticClass:"navbar navbar-expand-md navbar-dark bg-sky"},[_c('div',{staticClass:"container"},[_c('router-link',{staticClass:"navbar-brand",attrs:{"to":"/"}},[_vm._v("\n        Merkle Town"),_c('br'),_vm._v(" "),_c('span',{staticClass:"sub-brand"},[_vm._v("Explore the certificate transparency ecosystem.")])]),_vm._v(" "),_c('button',{staticClass:"navbar-toggler",attrs:{"type":"button","data-toggle":"collapse","data-target":"#navbarLinks","aria-controls":"navbarLinks","aria-expanded":"false","aria-label":"Toggle navigation"}},[_c('octicon',{attrs:{"name":"three-bars"}})],1),_vm._v(" "),_c('div',{staticClass:"collapse navbar-collapse",attrs:{"id":"navbarLinks"}},[_c('ul',{staticClass:"navbar-nav ml-auto"},[_c('li',{class:{'nav-item': true, 'active': _vm.onLogList}},[_c('router-link',{staticClass:"nav-link",attrs:{"to":"/logs"}},[_vm._v("Log List")])],1),_vm._v(" "),_c('li',{class:{'nav-item': true, 'active': _vm.onAbout}},[_c('router-link',{staticClass:"nav-link",attrs:{"to":"/about"}},[_vm._v("About")])],1)])])],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"loading-bg"}},[_c('div',{attrs:{"id":"loading-bar"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8X7C":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = itemize;
/* harmony export (immutable) */ __webpack_exports__["b"] = parse;
var entryTypes = {
  '1': 'Precert',
  '2': 'Cert',
  '3': 'CT-Qualified Cert'
};

var sigAlgs = {
  '1': 'RSA MD2',
  '2': 'RSA MD5',
  '3': 'RSA SHA-1',
  '4': 'RSA SHA-256',
  '5': 'RSA SHA-384',
  '6': 'RSA SHA-512',
  '7': 'DSA SHA-1',
  '8': 'DSA SHA-256',
  '9': 'ECDSA SHA-1',
  '10': 'ECDSA SHA-256',
  '11': 'ECDSA SHA-384',
  '12': 'ECDSA SHA-512',
  '13': 'PSS SHA-256',
  '14': 'PSS SHA-384',
  '15': 'PSS SHA-512'
};

var pubAlgs = {
  '1': 'RSA',
  '2': 'DSA',
  '3': 'ECDSA'
};

var valLevels = {
  '1': 'Domain',
  '2': 'Organization',
  '3': 'Extended'
};

function name(tag, names) {
  if (tag in names) {
    return names[tag];
  }
  return 'Other';
}

function add(obj, key, x) {
  if (key in obj) {
    obj[key] += x;
  } else {
    obj[key] = x;
  }
}

// itemize converts a map from bucket name -> count to a format that can be
// consumed by graph widgets. It pools any buckets that are too small to be
// visible into an Other bucket, if possible.
function itemize(obj) {
  var threshold = 0.02,
      buckets = 7;

  var data = [],
      total = 0;
  for (var key in obj) {
    data.push({ name: key, image: [key], count: obj[key] });
    total += obj[key];
  }

  var droppedKeys = [],
      droppedCount = 0;
  data = data.filter(function (x) {
    if (x.count / total < threshold) {
      droppedKeys.push(x.name);
      droppedCount += x.count;
      return false;
    }
    return true;
  });

  // Either add what was dropped to the standard Other bucket, or if there's
  // no Other bucket and we've filtered out >=2%, make a new Other bucket.
  var otherIdx = data.findIndex(function (x) {
    return x.name == 'Other';
  });
  if (otherIdx != -1) {
    data[otherIdx].image = data[otherIdx].image.concat(droppedKeys);
    data[otherIdx].count += droppedCount;
  } else if (droppedCount / total >= threshold) {
    data.push({ name: 'Other', image: droppedKeys, count: droppedCount });
    otherIdx = data.length - 1;
  } else {
    total -= droppedCount;
  }

  // If there are more buckets than we have colors, take the smallest buckets
  // and pool them into the Other bucket.
  if (data.length >= buckets) {
    // Put the Other bucket at the end; sort the rest of the array normally,
    // ascending by count.
    data = data.sort(function (x, y) {
      if (x.name == 'Other') {
        return 1;
      } else if (y.name == 'Other') {
        return -1;
      }
      return x.count - y.count;
    });

    if (otherIdx == -1) {
      data.push({ name: 'Other', image: [], count: 0 });
    }
    for (var i = 0; i < data.length - buckets; i++) {
      data[data.length - 1].image = data[data.length - 1].image.concat(data[i].image);
      data[data.length - 1].count += data[i].count;
    }
    data = data.slice(data.length - buckets);
  }

  // Sort the array in an aesthetically pleasing way, alphabetical with the
  // Other bucket at the end. Compute each bucket's percentage of the total.
  data = data.sort(function (x, y) {
    if (x.name == 'Other') {
      return 1;
    } else if (y.name == 'Other') {
      return -1;
    } else if (x.name < y.name) {
      return -1;
    } else if (x.name > y.name) {
      return 1;
    }
    return 0;
  });
  for (var _i = 0; _i < data.length; _i++) {
    data[_i].percent = data[_i].count / total;
  }

  return data;
}

function parse(breakdown, filters) {
  var acc = {
    'entryType': {},
    'sigAlg': {},
    'pubAlg': {},
    'valLevel': {},
    'rootName': {},
    'expired': {}
  };

  for (var key in breakdown) {
    var parts = key.split(':');

    var entryType = name(parts[0], entryTypes),
        sigAlg = name(parts[1], sigAlgs),
        pubAlg = name(parts[2], pubAlgs),
        valLevel = name(parts[3], valLevels),
        rootName = parts.slice(4).join(':');

    var skip = filters['entryType'] && !filters['entryType'].includes(entryType) || filters['sigAlg'] && !filters['sigAlg'].includes(sigAlg) || filters['pubAlg'] && !filters['pubAlg'].includes(pubAlg) || filters['valLevel'] && !filters['valLevel'].includes(valLevel) || filters['rootName'] && !filters['rootName'].includes(rootName);
    if (skip) {
      continue;
    }

    var e = 0,
        u = 0;
    if (!filters['expired'] || filters['expired'].includes('Expired')) {
      e = breakdown[key]['E'];
    }
    if (!filters['expired'] || filters['expired'].includes('Current')) {
      u = breakdown[key]['U'];
    }

    add(acc['entryType'], entryType, e + u);
    add(acc['sigAlg'], sigAlg, e + u);
    add(acc['pubAlg'], pubAlg, e + u);
    add(acc['valLevel'], valLevel, e + u);
    add(acc['rootName'], rootName, e + u);

    add(acc['expired'], 'Expired', e);
    add(acc['expired'], 'Current', u);
  }

  return {
    'entryType': itemize(acc['entryType']),
    'sigAlg': itemize(acc['sigAlg']),
    'pubAlg': itemize(acc['pubAlg']),
    'valLevel': itemize(acc['valLevel']),
    'rootName': itemize(acc['rootName']),
    'expired': itemize(acc['expired'])
  };
}

/***/ }),

/***/ "8i3U":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8kLh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9CAV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Navbar',
  computed: {
    onLogList: function onLogList() {
      return this.$route.path == '/logs';
    },
    onAbout: function onAbout() {
      return this.$route.path == '/about';
    }
  }
});

/***/ }),

/***/ "9vNX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[(_vm.error)?_c('Errorpage',{attrs:{"msg":_vm.error}}):_vm._e(),_vm._v(" "),(!_vm.error)?_c('table',{staticClass:"table table-hover table-responsive table-responsive-md"},[_vm._m(0),_vm._v(" "),_c('tbody',[_vm._l((_vm.logs),function(log){return [(!log.Family)?_c('tr',{on:{"click":function($event){return _vm.view(log.Slug)}}},[_c('td',[_vm._v(_vm._s(log.Name))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(log.Count.toLocaleString()))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.sprintPercent(log.Uptime)))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.sprintDuration(log.ResponseTime)))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.sprintDate(log.LastUpdate)))])]):[_c('tr',[_c('th',{attrs:{"colspan":"5"}},[_vm._v(_vm._s(log.FamilyName))])]),_vm._v(" "),_vm._l((log.Members),function(member){return _c('tr',{on:{"click":function($event){return _vm.view(member.Slug)}}},[_c('td',{staticClass:"family-member"},[_vm._v("— "+_vm._s(member.Name))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(member.Count.toLocaleString()))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.sprintPercent(member.Uptime)))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.sprintDuration(member.ResponseTime)))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.sprintDate(member.LastUpdate)))])])})]]})],2)]):_vm._e()],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('th',{attrs:{"scope":"col"}},[_vm._v("Log Name")]),_vm._v(" "),_c('th',{staticClass:"text-right",attrs:{"scope":"col"}},[_vm._v("# Certificates")]),_vm._v(" "),_c('th',{staticClass:"text-right",attrs:{"scope":"col"}},[_vm._v("Uptime")]),_vm._v(" "),_c('th',{staticClass:"text-right",attrs:{"scope":"col"}},[_vm._v("Resp. Time")]),_vm._v(" "),_c('th',{staticClass:"text-right",attrs:{"scope":"col"}},[_vm._v("Last Update")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "AAeu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('Navbar'),_vm._v(" "),_c('div',{staticClass:"container"},[_c('router-view')],1),_vm._v(" "),_c('Footbar')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "BlLf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ccha":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"id":'issuance-chart-'+_vm.id,"viewBox":"0,0,1000,300","preserveAspectRatio":"xMaxYMax meet"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "EV5V":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GNZh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IbL6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footbar_vue__ = __webpack_require__("XOjc");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_228d9e33_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Footbar_vue__ = __webpack_require__("cb0c");
function injectStyle (ssrContext) {
  __webpack_require__("plN1")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footbar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_228d9e33_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Footbar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "K+G5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Frontpage_vue__ = __webpack_require__("Lt/O");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b70d95a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Frontpage_vue__ = __webpack_require__("5BEz");
function injectStyle (ssrContext) {
  __webpack_require__("EV5V")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6b70d95a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Frontpage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b70d95a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Frontpage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "K2Iq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KgvX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* unused harmony export leftPad */
/* harmony export (immutable) */ __webpack_exports__["c"] = sprintDate;
/* unused harmony export sprintPercent */
/* harmony export (immutable) */ __webpack_exports__["d"] = sprintSmallPercent;
/* unused harmony export sprintDuration */
/* harmony export (immutable) */ __webpack_exports__["b"] = loadData;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


function leftPad(n, width, z) {
  z = z || '0';
  n = n + '';
  return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
}

// sprintDate takes an arbitrary date string as input (should be Universal
// Sortable, though) and returns it formatted as "YYYY-MM-DD HH:MM UTC".
function sprintDate(dateStr) {
  var d = new Date(dateStr);

  return leftPad(d.getUTCFullYear(), 4) + '-' + leftPad(d.getUTCMonth() + 1, 2) + '-' + leftPad(d.getUTCDate(), 2) + ' ' + leftPad(d.getUTCHours(), 2) + ':' + leftPad(d.getUTCMinutes(), 2) + ' UTC';
}

// sprintPercent takes a [0, 1] probability as input and returns it formatted as
// a percentage, with one decimal.
function sprintPercent(p) {
  return (p * 100).toFixed(1) + '%';
}

// sprintSmallPercent takes a [0, 1] probability as input and returns it
// formatted as a percented, rounded to the nearest integer.
function sprintSmallPercent(p) {
  return Math.round(p * 100) + '%';
}

// sprintDuration takes a duration in nanoseconds as input, converts it to a
// human-understandable unit, and return this along with the unit symbol.
function sprintDuration(d) {
  if (d < 1e+6) {
    // Less than a millisecond, show in microseconds.
    return Math.round(d / 1e+3) + 'μs';
  } else if (d < 1e+9) {
    // Less than a second, show in milliseconds.
    return Math.round(d / 1e+6) + 'ms';
  } // Show in seconds.
  return Math.round(d / 1e+9).toFixed(1) + 's';
}

// loadData asynchronously fetches data from the backend corresponding to tag.
// It is meant to be used in beforeRouteEnter lifecycle hooks, so `next` is the
// the same parameter as it is there.
//
// Consumers will need to implement a setData(err, data) method which is called
// with the result from the backend.
function loadData(tag, next) {
  if (global.preload[tag]) {
    next(function (vm) {
      return vm.setData(null, global.preload[tag]);
    });
    return;
  }

  var loadingBarBg = document.getElementById('loading-bg'),
      loadingBar = document.getElementById('loading-bar');
  if (loadingBarBg) {
    loadingBarBg.classList.add('bg-sky');
  }
  if (loadingBar) {
    loadingBar.classList.add('active');
  }

  __WEBPACK_IMPORTED_MODULE_0_axios__["get"]('/data' + tag, { timeout: 10000 }).then(function (resp) {
    if (loadingBarBg) {
      loadingBarBg.classList.remove('bg-sky');
    }
    if (loadingBar) {
      loadingBar.classList.remove('active');
    }
    global.preload[tag] = resp.data;
    next(function (vm) {
      return vm.setData(null, resp.data);
    });
  }).catch(function (err) {
    if (loadingBar) {
      loadingBar.classList.remove('active');
    }
    next(function (vm) {
      return vm.setData(err, null);
    });
  });
}

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    leftPad: leftPad,
    sprintDate: sprintDate,
    sprintPercent: sprintPercent,
    sprintSmallPercent: sprintSmallPercent,
    sprintDuration: sprintDuration
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("DuR2")))

/***/ }),

/***/ "Ls1+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VelocityGraph_vue__ = __webpack_require__("Su/m");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2efbd0a1_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VelocityGraph_vue__ = __webpack_require__("cxeO");
function injectStyle (ssrContext) {
  __webpack_require__("K2Iq")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2efbd0a1"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VelocityGraph_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2efbd0a1_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VelocityGraph_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Lt/O":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_mixins_roll__ = __webpack_require__("8X7C");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_mixins_util__ = __webpack_require__("KgvX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_widgets_Filters__ = __webpack_require__("MFeX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_widgets_CompGraph__ = __webpack_require__("x9ei");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_widgets_PieGraph__ = __webpack_require__("nmJD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_widgets_IssuanceGraph__ = __webpack_require__("55vb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_widgets_UtilGraph__ = __webpack_require__("aB4x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_widgets_Errorpage__ = __webpack_require__("zJhq");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Frontpage',
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    Object(__WEBPACK_IMPORTED_MODULE_2__components_mixins_util__["b" /* loadData */])('/index', next);
  },
  // beforeRouteUpdate omitted because this page has no parameters.

  data: function data() {
    return {
      error: null,

      data: null,
      breakdownFilters: {}
    };
  },
  computed: {
    breakdown: function breakdown() {
      return __WEBPACK_IMPORTED_MODULE_1__components_mixins_roll__["b" /* parse */](this.data.Breakdown, this.breakdownFilters);
    },
    legacySigAlgs: function legacySigAlgs() {
      var obj = this.data.Details.LegacySigAlgs,
          out = [];
      for (var key in obj) {
        out.push({ name: key, count: obj[key] });
      }
      return out.sort(function (a, b) {
        return a.count - b.count;
      });
    },
    legacyPubAlgs: function legacyPubAlgs() {
      var obj = this.data.Details.LegacyPubAlgs,
          out = [];
      for (var key in obj) {
        out.push({ name: key, count: obj[key] });
      }
      return out.sort(function (a, b) {
        return a.count - b.count;
      });
    }
  },
  methods: {
    setData: function setData(err, data) {
      if (err) {
        this.error = err.toString();
      } else {
        this.data = data;
      }
    },

    select: function select(field) {
      var self = this;
      return function (image) {
        var filters = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, self.breakdownFilters);
        filters[field] = image;
        self.breakdownFilters = filters;
      };
    },
    unselect: function unselect(field) {
      var filters = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.breakdownFilters);
      delete filters[field];
      this.breakdownFilters = filters;
    }
  },
  components: { Filters: __WEBPACK_IMPORTED_MODULE_3__components_widgets_Filters__["a" /* default */], CompGraph: __WEBPACK_IMPORTED_MODULE_4__components_widgets_CompGraph__["a" /* default */], PieGraph: __WEBPACK_IMPORTED_MODULE_5__components_widgets_PieGraph__["a" /* default */], IssuanceGraph: __WEBPACK_IMPORTED_MODULE_6__components_widgets_IssuanceGraph__["a" /* default */], UtilGraph: __WEBPACK_IMPORTED_MODULE_7__components_widgets_UtilGraph__["a" /* default */], Errorpage: __WEBPACK_IMPORTED_MODULE_8__components_widgets_Errorpage__["a" /* default */] }
});

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dfb35166_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("AAeu");
function injectStyle (ssrContext) {
  __webpack_require__("08S2")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dfb35166_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MFeX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Filters_vue__ = __webpack_require__("jmDQ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0847b964_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Filters_vue__ = __webpack_require__("g8v8");
function injectStyle (ssrContext) {
  __webpack_require__("2bLC")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0847b964"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Filters_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0847b964_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Filters_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "N+nW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3__ = __webpack_require__("vwbq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_mixins_roll__ = __webpack_require__("8X7C");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_mixins_util__ = __webpack_require__("KgvX");
//
//
//
//





var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

function issuance(data) {
  var out = [];

  for (var i = 0; i < data.length; i++) {
    var day = __WEBPACK_IMPORTED_MODULE_1__components_mixins_roll__["a" /* itemize */](data[i]),
        acc = 0;
    for (var j = 0; j < day.length; j++) {
      out.push({
        day: i,
        name: day[j].name,
        count: day[j].count,
        percent: day[j].percent,
        acc: acc
      });
      acc += day[j].count;
    }
  }

  return out;
}

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'IssuanceGraph',
  props: {
    id: { type: String, required: true },
    data: { type: Object, required: true }
  },
  data: function data() {
    return {
      color: __WEBPACK_IMPORTED_MODULE_0_d3__["j" /* scaleOrdinal */](['#98abc5', '#8a89a6', '#7b6888', '#6b486b', '#a05d56', '#d0743c', '#ff8c00'])
    };
  },
  methods: {
    draw: function draw() {
      var color = this.color,
          now = this.data.Now,
          data = issuance(this.data.Days);

      var yMax = __WEBPACK_IMPORTED_MODULE_0_d3__["g" /* max */](data, function (d) {
        return d.acc + d.count;
      });

      var x = __WEBPACK_IMPORTED_MODULE_0_d3__["i" /* scaleLinear */]().domain([0, 30]).range([55, 995]);
      var y = __WEBPACK_IMPORTED_MODULE_0_d3__["i" /* scaleLinear */]().domain([0, yMax]).range([295, 5]);

      var barWidth = (995 - 55) / 30;

      // Start drawing.
      var svg = __WEBPACK_IMPORTED_MODULE_0_d3__["k" /* select */]('svg#issuance-chart-' + this.id);
      svg.selectAll('*').remove();

      var g = svg.append('g').attr('transform', 'translate(0, 0)');

      // Draw a tooltip for detailed information about a specific block.
      var tooltipg = svg.append('g').attr('visibility', 'hidden');

      var tooltipRect1 = tooltipg.append('rect').attr('x', -6).attr('fill', '#e5e5e5');
      var tooltipRect2 = tooltipg.append('rect').attr('x', -5).attr('fill', 'white');

      var tooltip1 = tooltipg.append('text').attr('font-weight', 'bold').text('Date');
      var tooltip2 = tooltipg.append('text').attr('dx', '1.25em').attr('dy', '1.25em').text('Authority Name');
      var tooltip3 = tooltipg.append('text').attr('dx', '1.25em').attr('dy', '2.5em');

      var bbox1 = tooltip1._groups[0][0].getBBox();
      tooltipRect1.attr('y', bbox1.y - 6);
      tooltipRect2.attr('y', bbox1.y - 5);
      var bbox2 = tooltip2._groups[0][0].getBBox(),
          swatchY = bbox2.y + bbox2.height / 2 - 7;
      tooltipg.append('rect').attr('x', 0).attr('y', swatchY).attr('width', 14).attr('height', 14).attr('fill', '#e5e5e5');
      var tooltipSwatch = tooltipg.append('rect').attr('x', 1).attr('y', swatchY + 1).attr('width', 12).attr('height', 12);

      // Draw a histogram, with a bar for each day, split up by certificate
      // authority.
      var bar = g.selectAll('.bar').data(data).enter().append('g').attr('class', 'bar').attr('transform', function (d) {
        return 'translate(' + x(d.day) + ', ' + y(d.acc + d.count) + ')';
      }).on('mouseenter', function (d) {
        var t = new Date(now - (30 - d.day) * 86400 * 1000);
        tooltip1.text(months[t.getUTCMonth()] + ' ' + t.getUTCDate());
        tooltip2.text(d.name + ' (' + Object(__WEBPACK_IMPORTED_MODULE_2__components_mixins_util__["d" /* sprintSmallPercent */])(d.percent) + ')');
        tooltip3.text(d.count.toLocaleString());
        tooltipSwatch.attr('fill', color(d.name));

        var bbox2 = tooltip2._groups[0][0].getBBox(),
            bbox3 = tooltip3._groups[0][0].getBBox();
        tooltipRect1.attr('width', bbox2.x + bbox2.width + 12).attr('height', bbox3.y + bbox3.height - bbox1.y + 12);
        tooltipRect2.attr('width', bbox2.x + bbox2.width + 10).attr('height', bbox3.y + bbox3.height - bbox1.y + 10);

        var xPos = x(d.day) + barWidth + 10,
            yPos = (y(d.acc + d.count) + y(d.acc)) / 2;

        var rightSide = xPos + bbox2.x + bbox2.width + 12;
        if (rightSide > 1000) {
          xPos = x(d.day) - (bbox2.x + bbox2.width + 12);
        }
        var bottomSide = yPos + bbox3.y + bbox3.height + 12;
        if (bottomSide > 295) {
          yPos = 295 - (bbox3.y + bbox3.height + 5);
        }
        var topSide = yPos + bbox1.y;
        if (topSide < 0) {
          yPos = 10 - bbox1.y;
        }

        tooltipg.attr('transform', 'translate(' + xPos + ', ' + yPos + ')').attr('visibility', 'visible');
      }).on('mouseleave', function (d) {
        tooltipg.attr('visibility', 'hidden');
      });
      bar.append('rect') // Dark gray rect, gives illusion of 1px border.
      .attr('x', function (d) {
        return d.day == 0 ? 0 : -1;
      }).attr('width', barWidth).attr('height', function (d) {
        return 295 - y(d.count);
      }).attr('fill', '#e5e5e5');
      bar.append('rect') // Inner rect, colored for the specific CA.
      .attr('x', function (d) {
        return d.day == 0 ? 1 : 0;
      }).attr('y', 1).attr('width', barWidth - 1).attr('height', function (d) {
        return 295 - y(d.count);
      }).attr('fill', function (d) {
        return color(d.name);
      });

      // Draw the legend for the x-axis (y-axis omitted because its not useful).
      g.append('g').style('font-family', '\'Open Sans\', sans-serif').style('font-size', '0.9em').attr('transform', 'translate(55, 0)').call(__WEBPACK_IMPORTED_MODULE_0_d3__["b" /* axisLeft */](y).ticks(5, 's'));
    }
  },

  watch: {
    data: function data() {
      this.draw();
    }
  },
  mounted: function mounted() {
    this.draw();
  }
});

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_octicon_components_Octicon_vue__ = __webpack_require__("2+Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_octicon_icons_three_bars__ = __webpack_require__("h2/N");







__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('octicon', __WEBPACK_IMPORTED_MODULE_3_vue_octicon_components_Octicon_vue__["a" /* default */]);

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),

/***/ "QcKy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',[_vm._v("Failed to load page...")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.msg))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Su/m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3__ = __webpack_require__("vwbq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_mixins_util__ = __webpack_require__("KgvX");
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'VelocityGraph',
  props: {
    id: { type: String, required: true },
    data: { type: Array, required: true }
  },
  methods: {
    draw: function draw() {
      var xExtent = [this.data[0].start, this.data[this.data.length - 1].end];

      // Compute the extent of the y-axis by taking the max and min of d.added
      // and d.seen, and merging them. Then use 10% of the range as padding,
      // to keep the minimal points from hitting the bottom of the graph.
      var addedExtent = __WEBPACK_IMPORTED_MODULE_0_d3__["c" /* extent */](this.data, function (d) {
        return d.added;
      }),
          seenExtent = __WEBPACK_IMPORTED_MODULE_0_d3__["c" /* extent */](this.data, function (d) {
        return d.seen;
      });
      var yExtent = [Math.min(addedExtent[0], seenExtent[0]), Math.max(addedExtent[1], seenExtent[1])];
      var yRange = yExtent[1] - yExtent[0];
      if (yRange < 20) {
        yExtent[0] = Math.max(0, yExtent[0] - 2);
        yExtent[1] = yExtent[1] + 2;
      } else {
        yExtent[0] = Math.floor(yExtent[0] - 0.1 * yRange);
        yExtent[1] = Math.ceil(yExtent[1] + 0.1 * yRange);
        yExtent[0] = Math.max(0, yExtent[0]);
      }

      var x = __WEBPACK_IMPORTED_MODULE_0_d3__["i" /* scaleLinear */]().domain(xExtent).range([55, 745]);
      var y = __WEBPACK_IMPORTED_MODULE_0_d3__["i" /* scaleLinear */]().domain(yExtent).range([295, 5]);

      // Start drawing.
      var svg = __WEBPACK_IMPORTED_MODULE_0_d3__["k" /* select */]('svg#velocity-chart-' + this.id);
      svg.selectAll('*').remove();

      var g = svg.append('g').attr('transform', 'translate(0, 0)');

      // Draw a hidden reticle.
      var reticleg = svg.append('g').attr('transform', 'translate(0, 0)').attr('visibility', 'hidden');
      reticleg.append('line').attr('x1', 0).attr('y1', 5).attr('x2', 0).attr('y2', 295).attr('stroke', '#7b6888').attr('stroke-width', 1);

      var reticleArc = __WEBPACK_IMPORTED_MODULE_0_d3__["a" /* arc */]().outerRadius(7).innerRadius(3)({ startAngle: 0, endAngle: 2 * Math.PI });
      var reticle1 = reticleg.append('path').attr('fill', '#8a89a6').attr('opacity', 0.5).attr('d', reticleArc);
      var reticle2 = reticleg.append('path').attr('fill', '#98abc5').attr('opacity', 0.5).attr('d', reticleArc);

      // Draw a tooltip with detailed information next to the reticle.
      var tooltipg = reticleg.append('g').attr('transform', 'translate(25, 50)');

      var tooltipRect1 = tooltipg.append('rect').attr('x', -6).attr('fill', '#e5e5e5');
      var tooltipRect2 = tooltipg.append('rect').attr('x', -5).attr('fill', 'white');

      var tooltip1 = tooltipg.append('text').attr('font-weight', 'bold').text('Date');
      var tooltipLabel1 = tooltipg.append('text').attr('dx', '1.25em').attr('dy', '1.25em').text('Certs Seen');
      var tooltipLabel2 = tooltipg.append('text').attr('dx', '1.25em').attr('dy', '2.5em').text('Tree Growth');

      var bbox1 = tooltip1._groups[0][0].getBBox();
      tooltipRect1.attr('y', bbox1.y - 6);
      tooltipRect2.attr('y', bbox1.y - 5);
      var bbox2 = tooltipLabel1._groups[0][0].getBBox(),
          y1 = bbox2.y + bbox2.height / 2 - 7;
      tooltipg.append('rect').attr('x', 0).attr('y', y1).attr('width', 14).attr('height', 14).attr('fill', '#e5e5e5');
      tooltipg.append('rect').attr('x', 1).attr('y', y1 + 1).attr('width', 12).attr('height', 12).attr('fill', '#f4f4f4');
      var bbox3 = tooltipLabel2._groups[0][0].getBBox(),
          y2 = bbox3.y + bbox3.height / 2;
      tooltipg.append('line').attr('stroke', '#7b6888').attr('stroke-width', 2).attr('x1', 0).attr('y1', y2).attr('x2', bbox3.x - 3).attr('y2', y2);

      var tooltip2 = tooltipg.append('text').attr('text-anchor', 'end').attr('dx', '11em').attr('dy', '1.25em');
      var tooltip3 = tooltipg.append('text').attr('text-anchor', 'end').attr('dx', '11em').attr('dy', '2.5em');

      // Draw a histogram for the 'seen' dimension of the data.
      var bar = g.selectAll('.bar').data(this.data).enter().append('g').attr('class', 'bar').attr('transform', function (d) {
        return 'translate(' + x(d.start) + ', 0)';
      }).on('mouseenter', function (d) {
        reticle1.attr('transform', 'translate(0, ' + y(d.seen) + ')');
        reticle2.attr('transform', 'translate(0, ' + y(d.added) + ')');

        tooltip1.text(Object(__WEBPACK_IMPORTED_MODULE_1__components_mixins_util__["c" /* sprintDate */])(d.end));
        tooltip2.text(d.seen.toLocaleString());
        tooltip3.text(d.added.toLocaleString());

        var bbox = tooltip3._groups[0][0].getBBox();
        tooltipRect1.attr('width', bbox.x + bbox.width + 12).attr('height', bbox.y + bbox.height - bbox1.y + 12);
        tooltipRect2.attr('width', bbox.x + bbox.width + 10).attr('height', bbox.y + bbox.height - bbox1.y + 10);

        var rightSide = x(d.end) + 20 + bbox.x + bbox.width + 12;
        if (rightSide < 745) {
          tooltipg.attr('transform', 'translate(25, 50)');
        } else {
          var offsetX = -(20 + bbox.x + bbox.width + 12);
          tooltipg.attr('transform', 'translate(' + offsetX + ', 50)');
        }

        reticleg.attr('transform', 'translate(' + x(d.end) + ', 0)').attr('visibility', 'visible');
      }).on('mouseleave', function (d) {
        reticleg.attr('visibility', 'hidden');
      });
      bar.append('rect') // Invisible rect, for mouseover effects.
      .attr('width', function (d) {
        return x(d.end) - x(d.start);
      }).attr('height', 295).attr('fill', 'white');
      bar.append('rect') // Dark gray rect, gives illusion of 1px border.
      .attr('x', function (d, i) {
        return i == 0 ? 0 : -1;
      }).attr('y', function (d) {
        return y(d.seen);
      }).attr('width', function (d) {
        return x(d.end) - x(d.start) + 1;
      }).attr('height', function (d) {
        return 295 - y(d.seen);
      }).attr('fill', '#e5e5e5');
      bar.append('rect') // Inner rect, alternates between light and dark.
      .attr('x', function (d, i) {
        return i == 0 ? 1 : 0;
      }).attr('y', function (d) {
        return y(d.seen) + 1;
      }).attr('width', function (d) {
        return x(d.end) - x(d.start) - 1;
      }).attr('height', function (d) {
        return 295 - y(d.seen) - 1;
      }).attr('fill', function (d, i) {
        return i % 2 == 0 ? '#fafafa' : '#f4f4f4';
      });

      // Draw a line for the 'added' dimension of the data.
      var line = __WEBPACK_IMPORTED_MODULE_0_d3__["f" /* line */]().x(function (d) {
        return x(d.end);
      }).y(function (d) {
        return y(d.added);
      });
      g.append('path').datum(this.data).attr('fill', 'none').attr('stroke', '#7b6888').attr('stroke-width', 2).attr('stroke-linejoin', 'round').attr('stroke-linecap', 'round').attr('d', line).on('mouseenter', function (d) {
        reticleg.attr('visibility', 'visible');
      });

      // Draw the legend for the x-axis (y-axis omitted because its not useful).
      g.append('g').style('font-family', '\'Open Sans\', sans-serif').style('font-size', '14px').attr('transform', 'translate(55, 0)').call(__WEBPACK_IMPORTED_MODULE_0_d3__["b" /* axisLeft */](y).ticks(3, 's'));
    }
  },

  watch: {
    data: function data() {
      this.draw();
    }
  },
  mounted: function mounted() {
    this.draw();
  }
});

/***/ }),

/***/ "WeE0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__("FLAC");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var icons = {};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'octicon',
  props: {
    name: {
      type: String,
      validator: function validator(val) {
        if (val) {
          return val in icons;
        }
        return null;
      }
    },
    scale: [Number, String],
    spin: Boolean,
    inverse: Boolean,
    flip: {
      validator: function validator(val) {
        return val === 'horizontal' || val === 'vertical';
      }
    },
    label: String
  },
  data: function data() {
    return {
      x: false,
      y: false,
      childrenWidth: 0,
      childrenHeight: 0,
      outerScale: 1
    };
  },

  computed: {
    normalizedScale: function normalizedScale() {
      var scale = this.scale;
      scale = typeof scale === 'undefined' ? 1 : Number(scale);
      if (isNaN(scale) || scale <= 0) {
        Object(__WEBPACK_IMPORTED_MODULE_0__util__["a" /* warn */])('Invalid prop: prop "scale" should be a number over 0.', this);
        return this.outerScale;
      }
      return scale * this.outerScale;
    },
    clazz: function clazz() {
      return {
        'octicon': true,
        'octicon-spin': this.spin,
        'octicon-flip-horizontal': this.flip === 'horizontal',
        'octicon-flip-vertical': this.flip === 'vertical',
        'octicon-inverse': this.inverse
      };
    },
    icon: function icon() {
      if (this.name) {
        return icons[this.name];
      }
      return null;
    },
    box: function box() {
      if (this.icon) {
        if (this.icon.viewBox) {
          return this.icon.viewBox;
        }
        return '0 0 ' + this.icon.width + ' ' + this.icon.height;
      }
      return '0 0 ' + this.width + ' ' + this.height;
    },
    width: function width() {
      return this.childrenWidth || this.icon && this.icon.width * this.normalizedScale || 0;
    },
    height: function height() {
      return this.childrenHeight || this.icon && this.icon.height * this.normalizedScale || 0;
    },
    style: function style() {
      if (this.normalizedScale === 1) {
        return false;
      }
      return {
        fontSize: this.normalizedScale + 'em'
      };
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (this.icon) {
      return;
    }
    this.$children.forEach(function (child) {
      child.outerScale = _this.normalizedScale;
    });
    var width = 0;
    var height = 0;
    this.$children.forEach(function (child) {
      width = Math.max(width, child.width);
      height = Math.max(height, child.height);
    });
    this.childrenWidth = width;
    this.childrenHeight = height;
    this.$children.forEach(function (child) {
      child.x = (width - child.width) / 2;
      child.y = (height - child.height) / 2;
    });
  },
  register: function register(data) {
    for (var name in data) {
      icons[name] = data[name];
    }
  },

  icons: icons
});

/***/ }),

/***/ "WoGI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'NotFound'
});

/***/ }),

/***/ "X44g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Navbar_vue__ = __webpack_require__("9CAV");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_055c8c91_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Navbar_vue__ = __webpack_require__("7O1K");
function injectStyle (ssrContext) {
  __webpack_require__("fE7X")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Navbar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_055c8c91_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Navbar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "XOjc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Footbar'
});

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Frontpage__ = __webpack_require__("K+G5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_LogListpage__ = __webpack_require__("tND6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Logpage__ = __webpack_require__("zjwr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_About__ = __webpack_require__("c27y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_NotFound__ = __webpack_require__("YcJa");










__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Frontpage__["a" /* default */]
  }, {
    path: '/logs',
    component: __WEBPACK_IMPORTED_MODULE_3__components_LogListpage__["a" /* default */]
  }, {
    path: '/logs/:name',
    component: __WEBPACK_IMPORTED_MODULE_4__components_Logpage__["a" /* default */]
  }, {
    path: '/about',
    component: __WEBPACK_IMPORTED_MODULE_5__components_About__["a" /* default */]
  }, {
    path: '*',
    component: __WEBPACK_IMPORTED_MODULE_6__components_NotFound__["a" /* default */]
  }]
}));

/***/ }),

/***/ "YcJa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NotFound_vue__ = __webpack_require__("WoGI");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67ac73f0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotFound_vue__ = __webpack_require__("oDiI");
function injectStyle (ssrContext) {
  __webpack_require__("h8qX")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-67ac73f0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NotFound_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67ac73f0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotFound_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Zs8U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'About'
});

/***/ }),

/***/ "Zz25":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_mixins_util__ = __webpack_require__("KgvX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_widgets_Errorpage__ = __webpack_require__("zJhq");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'LogListpage',
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    Object(__WEBPACK_IMPORTED_MODULE_0__components_mixins_util__["b" /* loadData */])('/logs', next);
  },
  // beforeRouteUpdate omitted because this page has no parameters.

  data: function data() {
    return {
      error: null,
      logs: null
    };
  },
  methods: {
    setData: function setData(err, data) {
      if (err) {
        this.error = err.toString();
      } else {
        this.logs = data.Logs;
      }
    },

    view: function view(slug) {
      __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push({ path: '/logs/' + slug });
    }
  },
  components: { Errorpage: __WEBPACK_IMPORTED_MODULE_2__components_widgets_Errorpage__["a" /* default */] },
  mixins: [__WEBPACK_IMPORTED_MODULE_0__components_mixins_util__["a" /* default */]]
});

/***/ }),

/***/ "a2xD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3__ = __webpack_require__("vwbq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_mixins_compat__ = __webpack_require__("e1w8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_mixins_geometry__ = __webpack_require__("b1fz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_mixins_util__ = __webpack_require__("KgvX");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'PieGraph',
  props: {
    id: { type: String, required: true },
    data: { type: Array, required: true },
    select: { type: Function, default: null }
  },
  data: function data() {
    return {
      color: __WEBPACK_IMPORTED_MODULE_0_d3__["j" /* scaleOrdinal */](['#98abc5', '#8a89a6', '#7b6888', '#6b486b', '#a05d56', '#d0743c', '#ff8c00']),
      path: __WEBPACK_IMPORTED_MODULE_0_d3__["a" /* arc */]().outerRadius(122).innerRadius(0),
      pie: __WEBPACK_IMPORTED_MODULE_0_d3__["h" /* pie */]().sort(null).value(function (d) {
        return d.count;
      })
    };
  },
  methods: {
    draw: function draw() {
      var select = this.select,
          color = this.color,
          path = this.path,
          pie = this.pie;

      function key(d) {
        return d.data.name;
      }
      // arcTween defines how labels should move during animation. They should
      // smoothly expand/contract to their new size.
      function arcTween(d) {
        var i = __WEBPACK_IMPORTED_MODULE_0_d3__["d" /* interpolate */](this._current, d);
        this._current = i(0);
        return function (t) {
          return path(i(t));
        };
      }
      // labelTransformTween defines how slice labels should move during
      // animation. Labels always try to stay in the middle of their slice.
      function labelTransformTween(d) {
        var isWhole = d.data.percent == 1,
            wasWhole = this._current.data && this._current.data.percent == 1;

        if (isWhole && wasWhole) {
          this._current = d;
          return function (t) {
            return 'translate(0, 0)';
          };
        } else if (isWhole) {
          var _i = __WEBPACK_IMPORTED_MODULE_0_d3__["e" /* interpolateString */]('translate(' + path.centroid(this._current) + ')', 'translate(0, 0)');
          this._current = d;
          return _i;
        } else if (wasWhole) {
          var _i2 = __WEBPACK_IMPORTED_MODULE_0_d3__["e" /* interpolateString */]('translate(0, 0)', 'translate(' + path.centroid(d) + ')');
          this._current = d;
          return _i2;
        }
        var i = __WEBPACK_IMPORTED_MODULE_0_d3__["d" /* interpolate */](this._current, d);
        this._current = i(0);
        return function (t) {
          return 'translate(' + path.centroid(i(t)) + ')';
        };
      }

      var svg = __WEBPACK_IMPORTED_MODULE_0_d3__["k" /* select */]('svg#pie-chart-' + this.id),
          g = svg.select('g'),
          tooltipg = g.select('g.tooltipg'),
          arc = g.selectAll('.arc');

      function arcMouseover(d) {
        if (d.data.percent == 1) {
          return;
        }

        var tooltip = tooltipg.select('text');
        tooltip.select('tspan.name').text(d.data.name);
        tooltip.select('tspan.count').text(d.data.count.toLocaleString() + ' certs');
        tooltip.select('tspan.percent').text(__WEBPACK_IMPORTED_MODULE_3__components_mixins_util__["a" /* default */].methods.sprintSmallPercent(d.data.percent));

        tooltipg.select('circle.body').style('fill', color(d.data.name));

        tooltipg.attr('transform', 'translate(0, 0)').raise();
        g.selectAll('text.pie-label').attr('visibility', 'hidden');
      }
      function arcMouseout(d) {
        tooltipg.attr('transform', 'translate(-500, -500)');
        g.selectAll('text.pie-label').attr('visibility', function (d) {
          if (__WEBPACK_IMPORTED_MODULE_2__components_mixins_geometry__["e" /* labelWillFit */](path.centroid(d), d)) {
            return 'visible';
          }
          return 'hidden';
        });
      }
      function arcClick(d) {
        if (d.data.percent == 1 || select == null) {
          return;
        }
        select(d.data.image);
        arcMouseout(d);
      }

      var data0 = arc.data(),
          data1 = pie(this.data);

      arc = arc.data(data1, key);

      var arcEnter = arc.enter().append('g').attr('class', 'arc');
      // Create a new slice of pie, whose colors corresponds to its name.
      arcEnter.append('path').each(function (d, i) {
        this._current = __WEBPACK_IMPORTED_MODULE_2__components_mixins_geometry__["a" /* findArcEntry */](i, data0, data1, key) || d;
      }).attr('fill', function (d) {
        return color(d.data.name);
      }).on(__WEBPACK_IMPORTED_MODULE_1__components_mixins_compat__["d" /* mouseover */](), arcMouseover).on(__WEBPACK_IMPORTED_MODULE_1__components_mixins_compat__["c" /* mouseout */](), arcMouseout).on(__WEBPACK_IMPORTED_MODULE_1__components_mixins_compat__["a" /* click */](), arcClick);
      // Create a 3-line label for the slice's name and other info.
      var label = arcEnter.append('text').each(function (d, i) {
        this._current = __WEBPACK_IMPORTED_MODULE_2__components_mixins_geometry__["a" /* findArcEntry */](i, data0, data1, key) || d;
      }).attr('class', 'pie-label').attr('fill', 'white').attr('text-anchor', 'middle');
      label.append('tspan').attr('x', 0).attr('dy', '0em').text(function (d) {
        return d.data.name;
      });
      label.append('tspan').attr('x', 0).attr('dy', '1.25em').attr('class', 'count');
      label.append('tspan').attr('x', 0).attr('dy', '1.25em').attr('class', 'percent');

      var arcUpdate = arcEnter.merge(arc).transition().duration(750);
      arcUpdate.select('path').attrTween('d', arcTween).style('cursor', function (d) {
        return d.data.percent == 1 || select == null ? 'default' : 'pointer';
      });
      label = arcUpdate.select('text').attrTween('transform', labelTransformTween) // Move labels to the middle of their slice.
      .attr('visibility', function (d) {
        // Hide labels that don't fit w/in their slice.
        if (d.data.percent == 1 || __WEBPACK_IMPORTED_MODULE_2__components_mixins_geometry__["e" /* labelWillFit */](path.centroid(d), d)) {
          return 'visible';
        }
        return 'hidden';
      });
      label.select('tspan.count') // If a slice is 100%, write the exact count in a middle line.
      .text(function (d) {
        return d.data.percent == 1 ? d.data.count.toLocaleString() + " certs" : "";
      });
      label.select('tspan.percent') // On the bottom line, write the slice's percentage.
      .text(function (d) {
        return __WEBPACK_IMPORTED_MODULE_3__components_mixins_util__["a" /* default */].methods.sprintSmallPercent(d.data.percent);
      });

      var arcExit = arc.exit();
      arcExit.select('text').remove();
      arcExit = arcExit.datum(function (d, i) {
        return __WEBPACK_IMPORTED_MODULE_2__components_mixins_geometry__["b" /* findArcExit */](i, data0, data1, key) || d;
      }).transition().duration(750);
      arcExit.select('path').attrTween('d', arcTween);
      arcExit.remove();
    }
  },

  watch: {
    data: function data() {
      this.draw();
    }
  },
  mounted: function mounted() {
    var path = this.path;

    var svg = __WEBPACK_IMPORTED_MODULE_0_d3__["k" /* select */]('svg#pie-chart-' + this.id);
    svg.select('g.tooltipg').on(__WEBPACK_IMPORTED_MODULE_1__components_mixins_compat__["d" /* mouseover */](), function (d) {
      __WEBPACK_IMPORTED_MODULE_0_d3__["k" /* select */](this).attr('transform', 'translate(0, 0)');
      svg.selectAll('text.pie-label').attr('visibility', 'hidden');
    }).on(__WEBPACK_IMPORTED_MODULE_1__components_mixins_compat__["c" /* mouseout */](), function (d) {
      __WEBPACK_IMPORTED_MODULE_0_d3__["k" /* select */](this).attr('transform', 'translate(-500, -500)');
      svg.selectAll('text.pie-label').attr('visibility', function (d) {
        if (__WEBPACK_IMPORTED_MODULE_2__components_mixins_geometry__["e" /* labelWillFit */](path.centroid(d), d)) {
          return 'visible';
        }
        return 'hidden';
      });
    });

    this.draw();
  }
});

/***/ }),

/***/ "aB4x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UtilGraph_vue__ = __webpack_require__("1TdX");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64659e91_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UtilGraph_vue__ = __webpack_require__("vwga");
function injectStyle (ssrContext) {
  __webpack_require__("3h0Q")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-64659e91"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UtilGraph_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64659e91_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UtilGraph_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "aOIe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"id":'comp-chart-'+_vm.id}},[_c('rect',{staticClass:"swatch",attrs:{"x":"0","y":"0","fill":"white"}}),_vm._v(" "),_c('text',{staticClass:"tooltipt",attrs:{"x":"3","y":"0"}}),_vm._v(" "),_c('rect',{staticClass:"borderr",attrs:{"x":"0","width":"100%","fill":"#e5e5e5"}}),_vm._v(" "),_c('g',{staticClass:"blocksg"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "b1fz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["e"] = labelWillFit;
/* harmony export (immutable) */ __webpack_exports__["a"] = findArcEntry;
/* harmony export (immutable) */ __webpack_exports__["b"] = findArcExit;
/* harmony export (immutable) */ __webpack_exports__["c"] = findBlockEntry;
/* harmony export (immutable) */ __webpack_exports__["d"] = findBlockExit;
// angle returns the angle in radians between the point [0, 0] and pt, where
// angle([0, x]) returns 0 for negative x, and pi for positive x.
function angle(pt) {
  var out = Math.atan(-pt[1] / pt[0]);
  out = Math.PI / 2 - out;

  if (pt[0] < 0) {
    out += Math.PI;
  }

  return out;
}

// labelWillFit is a heuristic method to determine if a label on a pie chart
// will fit between the two rays from the center of the pie. centroid is the
// point [x, y] where the center of the label goes, d is data about the slice.
function labelWillFit(centroid, d) {
  // We assume that the label is two lines, each centered, and that each line is
  // 30px high with characters that are 7px wide.

  var labelLen = 8 * d.data.name.length,
      percentLen = 8 * 4;

  var pts = [[centroid[0] - labelLen / 2, centroid[1] + 15], // Corners of label text box.
  [centroid[0] + labelLen / 2, centroid[1] + 15], [centroid[0] - labelLen / 2, centroid[1] - 15], [centroid[0] + labelLen / 2, centroid[1] - 15], [centroid[0] - percentLen / 2, centroid[1] - 15], // Corners of percent text box.
  [centroid[0] + percentLen / 2, centroid[1] - 15], [centroid[0] - percentLen / 2, centroid[1] - 30], [centroid[0] + percentLen / 2, centroid[1] - 30]];

  // There are two rays from the origin of the pie graph. All points should be
  // between these two rays.
  for (var i = 0; i < pts.length; i++) {
    var theta = angle(pts[i]);
    if (theta < d.startAngle || theta > d.endAngle) {
      return false;
    }
  }

  return true;
}

function findPreceding(i, data0, data1, key) {
  var m = data0.length;
  while (--i >= 0) {
    var k = key(data1[i]);
    for (var j = 0; j < m; ++j) {
      if (key(data0[j]) === k) return data0[j];
    }
  }
}

function findFollowing(i, data0, data1, key) {
  var n = data1.length,
      m = data0.length;
  while (++i < n) {
    var k = key(data1[i]);
    for (var j = 0; j < m; ++j) {
      if (key(data0[j]) === k) return data0[j];
    }
  }
}

// findArcEntry assumes that data0 has already been drawn and that we're moving
// to data1, where data1[i] is a new data point. It returns the location where
// the slice for data1[i] should "bloom" from.
function findArcEntry(i, data0, data1, key) {
  if (data0.length == 0) {
    return null;
  }
  var d = findPreceding(i, data0, data1, key);
  if (d) {
    return { startAngle: d.endAngle, endAngle: d.endAngle };
  }
  return { startAngle: 0, endAngle: 0 };
}

// findArcExit assumes that data0 has already been drawn and that we're moving
// to data1, where data0[i] is a data point which was completely removed from
// data1. It returns the location where the slice for data0[i] should "collapse"
// to before being deleted.
function findArcExit(i, data0, data1, key) {
  var d = findFollowing(i, data1, data0, key);
  if (d) {
    return { startAngle: d.startAngle, endAngle: d.startAngle };
  }
  return { startAngle: 2 * Math.PI, endAngle: 2 * Math.PI };
}

// findBlockEntry is findArcEntry for a CompGraph.
function findBlockEntry(i, data0, data1, key) {
  if (data0.length == 0) {
    return null;
  }
  var d = findPreceding(i, data0, data1, key);
  if (d) {
    return { start: d.end, end: d.end };
  }
  return { start: 0, end: 0 };
}

// findBlockExit is findBlockExit for a CompGraph.
function findBlockExit(i, data0, data1, key) {
  var d = findFollowing(i, data1, data0, key);
  if (d) {
    return { start: d.start, end: d.start };
  }
  return { start: 1, end: 1 };
}

/***/ }),

/***/ "c27y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_About_vue__ = __webpack_require__("Zs8U");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0390e838_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_About_vue__ = __webpack_require__("tRFq");
function injectStyle (ssrContext) {
  __webpack_require__("8i3U")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0390e838"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_About_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0390e838_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_About_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "cb0c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"container"},[_c('span',{staticClass:"text-muted"},[_vm._v("© 2019 Cloudflare, Inc.")]),_vm._v(" "),_c('div',[_c('a',{staticClass:"text-muted",attrs:{"href":"https://www.cloudflare.com/privacypolicy/"}},[_vm._v("Privacy Policy")]),_vm._v(" "),_c('a',{staticClass:"text-muted",attrs:{"href":"https://www.cloudflare.com/website-terms/"}},[_vm._v("Terms of Use")]),_vm._v(" "),_c('a',{staticClass:"text-muted",attrs:{"href":"https://www.cloudflare.com/abuse/"}},[_vm._v("Trust & Safety")]),_vm._v(" "),_c('a',{staticClass:"text-muted",attrs:{"href":"https://www.cloudflare.com/trademark/"}},[_vm._v("Trademark")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "cxeO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"id":'velocity-chart-'+_vm.id,"viewBox":"0,0,750,300","preserveAspectRatio":"xMaxYMax meet"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "e1w8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = mouseover;
/* harmony export (immutable) */ __webpack_exports__["b"] = mouseleave;
/* harmony export (immutable) */ __webpack_exports__["c"] = mouseout;
/* harmony export (immutable) */ __webpack_exports__["a"] = click;
function touchscreen() {
  return 'ontouchstart' in window || navigator.maxTouchPoints;
}

function mouseover() {
  return 'mouseover';
}
function mouseleave() {
  return 'mouseleave';
}
function mouseout() {
  return 'mouseout';
}

function click() {
  if (touchscreen()) {
    return 'dblclick';
  }
  return 'click';
}

/***/ }),

/***/ "fE7X":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fyq0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "g8v8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.breakdownFilters),function(image,field){return _c('span',{staticClass:"badge badge-secondary"},[_vm._v("\n    "+_vm._s(_vm.names[field])+": "+_vm._s(_vm.sprintImage(image))+" "),_c('span',{staticClass:"times",on:{"click":function($event){return _vm.unselect(field)}}},[_vm._v("×")])])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "h75S":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_mixins_roll__ = __webpack_require__("8X7C");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_mixins_util__ = __webpack_require__("KgvX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_widgets_Filters__ = __webpack_require__("MFeX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_widgets_CompGraph__ = __webpack_require__("x9ei");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_widgets_PieGraph__ = __webpack_require__("nmJD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_widgets_VelocityGraph__ = __webpack_require__("Ls1+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_widgets_Errorpage__ = __webpack_require__("zJhq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_NotFound__ = __webpack_require__("YcJa");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Logpage',
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    Object(__WEBPACK_IMPORTED_MODULE_2__components_mixins_util__["b" /* loadData */])('/logs/' + to.params.name, next);
  },
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    Object(__WEBPACK_IMPORTED_MODULE_2__components_mixins_util__["b" /* loadData */])('/logs/' + to.params.name, next);
  },

  data: function data() {
    return {
      error: null,
      log: null,

      breakdownFilters: {},

      endpoints: [{ tag: 'add-chain-new', name: 'add-chain (new)' }, { tag: 'add-chain-old', name: 'add-chain (old)' }, { tag: 'add-pre-chain-new', name: 'add-pre-chain (new)' }, { tag: 'add-pre-chain-old', name: 'add-pre-chain (old)' }, { tag: 'get-entries', name: 'get-entries' }, { tag: 'get-roots', name: 'get-roots' }, { tag: 'get-sth', name: 'get-sth' }]
    };
  },
  computed: {
    breakdown: function breakdown() {
      return __WEBPACK_IMPORTED_MODULE_1__components_mixins_roll__["b" /* parse */](this.log.Breakdown, this.breakdownFilters);
    },

    atCapacity: function atCapacity() {
      return this.log.Name == 'DigiCert 1' || this.log.Name == 'DigiCert 2';
    },

    velocity: function velocity() {
      return this.log.Velocity.map(function (v) {
        return { start: v.Start, end: v.End, added: v.Added, seen: v.Seen };
      });
    },
    throughput: function throughput() {
      if (this.velocity.length == 0) {
        return 0;
      }

      var hourInMs = 3600 * 1000;
      var total = this.velocity.reduce(function (n, d) {
        return n + d.added;
      }, 0),
          extent = this.velocity[this.velocity.length - 1].end - this.velocity[0].start;
      return Math.round(total / (extent / hourInMs));
    }
  },
  methods: {
    setData: function setData(err, data) {
      if (err) {
        this.error = err.toString();
        if (this.error == 'Error: Request failed with status code 404') {
          this.error = null;
        }
      } else {
        this.log = data;
      }
    },
    select: function select(field) {
      var self = this;
      return function (image) {
        var filters = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, self.breakdownFilters);
        filters[field] = image;
        self.breakdownFilters = filters;
      };
    },
    unselect: function unselect(field) {
      var filters = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.breakdownFilters);
      delete filters[field];
      this.breakdownFilters = filters;
    }
  },
  components: { Filters: __WEBPACK_IMPORTED_MODULE_3__components_widgets_Filters__["a" /* default */], CompGraph: __WEBPACK_IMPORTED_MODULE_4__components_widgets_CompGraph__["a" /* default */], PieGraph: __WEBPACK_IMPORTED_MODULE_5__components_widgets_PieGraph__["a" /* default */], VelocityGraph: __WEBPACK_IMPORTED_MODULE_6__components_widgets_VelocityGraph__["a" /* default */], Errorpage: __WEBPACK_IMPORTED_MODULE_7__components_widgets_Errorpage__["a" /* default */], NotFound: __WEBPACK_IMPORTED_MODULE_8__components_NotFound__["a" /* default */] },
  mixins: [__WEBPACK_IMPORTED_MODULE_2__components_mixins_util__["a" /* default */]]
});

/***/ }),

/***/ "h8qX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jME9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jmDQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Filters',
  props: {
    breakdownFilters: { type: Object, required: true },
    unselect: { type: Function, required: true }
  },
  data: function data() {
    return {
      names: {
        'valLevel': 'Validation Level',
        'pubAlg': 'Public-Key Alg',
        'sigAlg': 'Signature Alg',
        'entryType': 'Entry Type',
        'expired': 'Status',
        'rootName': 'Root Authority'
      }
    };
  },
  methods: {
    sprintImage: function sprintImage(image) {
      if (image.length > 3) {
        return '(several values)';
      }
      return image.join(', ');
    }
  }
});

/***/ }),

/***/ "jnhO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3__ = __webpack_require__("vwbq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_mixins_compat__ = __webpack_require__("e1w8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_mixins_geometry__ = __webpack_require__("b1fz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_mixins_util__ = __webpack_require__("KgvX");
//
//
//
//
//
//
//
//
//
//
//
//
//
//






function comp(data) {
  var out = [],
      acc = 0,
      total = data.reduce(function (n, d) {
    return n + d.count;
  }, 0);

  for (var i = 0; i < data.length; i++) {
    out.push({
      data: data[i],
      index: i,
      start: acc / total,
      end: (acc + data[i].count) / total
    });
    acc += data[i].count;
  }

  return out;
}
function min(x) {
  return x < 0 ? 0 : x;
}

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'CompGraph',
  props: {
    id: { type: String, required: true },
    data: { type: Array, required: true },
    select: { type: Function, default: null },

    unit: { type: String, default: 'certs' },
    palette: { type: Function, default: null }
  },
  data: function data() {
    var timer = null,
        self = this;
    // debounceResize re-draws the CompGraph when the window resizes, with a
    // 50ms debounce to minimize lag.
    var debounceResize = function debounceResize() {
      clearTimeout(timer);
      timer = setTimeout(self.resize, 50);
    };

    var color = __WEBPACK_IMPORTED_MODULE_0_d3__["j" /* scaleOrdinal */](['#98abc5', '#8a89a6', '#7b6888', '#6b486b', '#a05d56', '#d0743c', '#ff8c00']);
    if (this.palette != null) {
      color = this.palette;
    }
    return {
      debounceResize: debounceResize,

      blocksHeight: 0,
      blocksWidth: 0,
      color: color
    };
  },
  methods: {
    resize: function resize() {
      var svg = __WEBPACK_IMPORTED_MODULE_0_d3__["k" /* select */]('svg#comp-chart-' + this.id),
          swatch = svg.select('rect.swatch'),
          tooltip = svg.select('text.tooltipt'),
          g = svg.select('g.blocksg');

      // The tooltip must have text for getBBox below to work.
      var tooltipText = tooltip.text();
      tooltip.attr('fill', 'white').text('Loading...');

      // Get the size of the whole image 'clientRect' and the size of the
      // tooltip 'rect'.
      var clientRect = svg._groups[0][0].getBoundingClientRect(),
          rect = tooltip._groups[0][0].getBBox();

      var tooltipDy = -rect.y;
      if (tooltip.attr('dy') != null) {
        tooltipDy += parseFloat(tooltip.attr('dy'));
      }

      // Clean up positioning of swatch and tooltip with info from above.
      swatch.attr('width', rect.height).attr('height', rect.height);
      tooltip.attr('dx', rect.height).attr('dy', tooltipDy).text(tooltipText).attr('fill', 'black');
      rect.height += 3;

      svg.select('rect.borderr').attr('y', rect.height).attr('height', clientRect.height - rect.height);
      g.attr('transform', 'translate(3, ' + (3 + rect.height) + ')');

      // Resize and re-position all of the already-drawn blocks.
      var blocksHeight = clientRect.height - rect.height - 3 * 2,
          blocksWidth = clientRect.width - 3 * 2;

      g.selectAll('rect.block').attr('height', blocksHeight).attr('width', function (d) {
        return min(d.end - d.start) * blocksWidth;
      }).attr('x', function (d) {
        return d.start * blocksWidth;
      });

      this.blocksHeight = blocksHeight, this.blocksWidth = blocksWidth;
    },
    draw: function draw() {
      var select = this.select,
          unit = this.unit,
          blocksHeight = this.blocksHeight,
          blocksWidth = this.blocksWidth,
          color = this.color;

      function key(d) {
        return d.data.name;
      }
      function blockTween(d) {
        var node = this,
            i = __WEBPACK_IMPORTED_MODULE_0_d3__["d" /* interpolate */](this._current, d);
        node._current = i(0);
        return function (t) {
          var u = i(t);
          node.setAttribute('x', u.start * blocksWidth);
          node.setAttribute('width', min(u.end - u.start) * blocksWidth);
        };
      }

      var svg = __WEBPACK_IMPORTED_MODULE_0_d3__["k" /* select */]('svg#comp-chart-' + this.id),
          swatch = svg.select('rect.swatch'),
          tooltip = svg.select('text.tooltipt'),
          blocks = svg.select('g.blocksg').selectAll('rect.block');

      var data0 = blocks.data(),
          data1 = comp(this.data);

      blocks = blocks.data(data1, key);

      blocks.enter().append('rect').attr('class', 'block').each(function (d, i) {
        this._current = __WEBPACK_IMPORTED_MODULE_2__components_mixins_geometry__["c" /* findBlockEntry */](i, data0, data1, key) || d;
      }).attr('height', blocksHeight).attr('fill', function (d) {
        return color(d.data.name);
      }).on(__WEBPACK_IMPORTED_MODULE_1__components_mixins_compat__["d" /* mouseover */](), function (d) {
        swatch.attr('fill', color(d.data.name));

        var spacer = '\xA0\xA0\xA0\u2022\xA0\xA0\xA0';
        tooltip.text(d.data.name + ' ' + '(' + Object(__WEBPACK_IMPORTED_MODULE_3__components_mixins_util__["d" /* sprintSmallPercent */])(d.data.percent) + ')' + '\xA0\xA0\xA0-\xA0\xA0\xA0' + d.data.count.toLocaleString() + ' ' + unit);
      }).on(__WEBPACK_IMPORTED_MODULE_1__components_mixins_compat__["a" /* click */](), function (d) {
        if (d.data.percent == 1 || select == null) {
          return;
        }
        select(d.data.image);
        svg.select('rect.swatch').attr('fill', 'white');
        svg.select('text.tooltipt').text('');
      }).merge(blocks).transition().duration(750).tween('block', blockTween).style('cursor', function (d) {
        return d.data.percent == 1 || select == null ? 'default' : 'pointer';
      });

      blocks.exit().datum(function (d, i) {
        return __WEBPACK_IMPORTED_MODULE_2__components_mixins_geometry__["d" /* findBlockExit */](i, data0, data1, key) || d;
      }).transition().duration(750).tween('block', blockTween).remove();
    }
  },

  watch: {
    data: function data() {
      this.draw();
    }
  },
  mounted: function mounted() {
    var svg = __WEBPACK_IMPORTED_MODULE_0_d3__["k" /* select */]('svg#comp-chart-' + this.id);
    svg.on(__WEBPACK_IMPORTED_MODULE_1__components_mixins_compat__["b" /* mouseleave */](), function (d) {
      svg.select('rect.swatch').attr('fill', 'white');
      svg.select('text.tooltipt').text('');
    });

    this.resize();
    this.draw();
    window.addEventListener('resize', this.debounceResize);
  },
  destroyed: function destroyed() {
    window.removeEventListener('resize', this.debounceResize);
  }
});

/***/ }),

/***/ "nmJD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PieGraph_vue__ = __webpack_require__("a2xD");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_452b4583_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PieGraph_vue__ = __webpack_require__("7Dgi");
function injectStyle (ssrContext) {
  __webpack_require__("fyq0")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-452b4583"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PieGraph_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_452b4583_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PieGraph_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "oDiI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',[_vm._v("Not Found")]),_vm._v(" "),_c('p',[_vm._v("The requested page was not found.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "pC6E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Errorpage',
  props: {
    msg: String
  }
});

/***/ }),

/***/ "plN1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tND6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LogListpage_vue__ = __webpack_require__("Zz25");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61a82ece_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LogListpage_vue__ = __webpack_require__("9vNX");
function injectStyle (ssrContext) {
  __webpack_require__("/Pi3")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-61a82ece"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LogListpage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61a82ece_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LogListpage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "tRFq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-2"}),_c('div',{staticClass:"col-md-8"},[_c('h6',[_vm._v("Introduction")]),_vm._v(" "),_c('p',[_c('a',{attrs:{"href":"https://www.certificate-transparency.org/what-is-ct"}},[_vm._v("Certificate\n  Transparency")]),_vm._v(" is an experimental framework for publicly auditing the\n  TLS/SSL certificates issued by certificate authorities. It does this by\n  requiring an increasing number of issued certificates to be added to\n  publicly-accessible repositories, called "),_c('em',[_vm._v("certificate transparency\n  logs")]),_vm._v(", in order for them to be trusted by the user's browser. The goal\n  is two-fold:")]),_vm._v(" "),_c('ol',[_c('li',[_c('strong',[_vm._v("Easy detection of mis-issued certificates.")]),_vm._v(" Because\n      certificates must be submitted to several certificate transparency logs\n      to be trusted in-browser, website owners can also search through these\n      same logs and get an authoritative list of all certificates that have\n      been issued for their website.\n    ")]),_vm._v(" "),_c('li',[_c('strong',[_vm._v("Better oversight and understanding of the entire TLS/SSL\n      ecosystem.")]),_vm._v(" Crawling certificate transparency logs gives deep\n      insight into the types of certificates being issued, and the scale of\n      different certificate authorities.\n    ")])]),_vm._v(" "),_c('p',[_vm._v("In addition to CT logs, there need to be "),_c('em',[_vm._v("certificate transparency\n  monitors")]),_vm._v(". The primary function of a monitor is to ensure that CT logs\n  behave correctly, e.g., by ensuring that they continue to store and serve\n  "),_c('em',[_vm._v("all")]),_vm._v(" certificates that have been submitted to them. However, it is\n  also common for monitors to use the data they collect from CT logs to offer\n  other services such as computing ecosystem metrics, searching known\n  certificates, and triggering alerts when new certificates are issued for\n  certain domain names.")]),_vm._v(" "),_c('h6',[_vm._v("Methodology")]),_vm._v(" "),_c('p',[_vm._v("This monitor fetches each log's current Signed Tree Head (STH) and set of\n  trusted roots once per minute. New entries in a log are crawled as\n  appropriate, and we will occasionally submit strictly-valid unexpired\n  certificates or pre-certificates to a log. If a log is sharded by year, we\n  will only submit certificates expiring in that year.")]),_vm._v(" "),_c('p',[_c('em',[_vm._v("All")]),_vm._v(" requests to a log count towards our estimate of its uptime\n  and response time. An endpoint's (get-sth, get-entries, etc.) uptime is\n  computed as the percentage of requests to that endpoint that succeed (that\n  is, return a 200 status code with a valid response) out of a 90 day rolling\n  window. An endpoint's response time is computed as the average amount of\n  time from when a request is sent until the response is fully received and\n  parsed, in a 90 day rolling window. A log's uptime and response time is\n  computed as a "),_c('em',[_vm._v("fair average")]),_vm._v(" of each endpoint's uptime and response\n  time. Requests are made with the HTTP client in Golang's standard library.\n  We do not contact endpoints that are not listed on a log's informational\n  page, such as get-proof-by-hash and get-sth-consistency.")]),_vm._v(" "),_c('p',[_vm._v("Some parts of the monitor may enforce different timeouts or will retry in\n  the event that a request fails while other parts will not, which means that\n  downtime may be penalized unfairly relative to a more intuitive\n  interpretation of 'downtime'. Also, the response time of the get-entries\n  endpoint is strongly correlated with the number of entries it\n  returns, but this information is currently ignored by our monitor.")]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("Fullness and New/Old Chains.")]),_vm._v(" On each log's informational\n  page, we display an estimate of the number of unsubmitted certificates. This\n  is computed by counting all the certificates in the CT ecosystem that we\n  expect a log would accept, based on its trusted root CAs and whether the log\n  is sharded by year, and subtracting the number of unique certificates the\n  log contains. The log's 'fullness' is computed as the percentage of\n  certificates it contains out of the set of certificates we expect it would\n  accept.")]),_vm._v(" "),_c('p',[_vm._v("Similarly, we break uptime and response time estimates for the\n  add-(pre-)chain endpoints into 'new' and 'old' categories, corresponding to\n  whether or not the submitted chain is already in the log (old) or is not\n  (new). It is common for logs to de-duplicate submitted chains, returning the\n  same SCT when the same chain is submitted multiple times, so we do this to\n  measure the cases where the de-duplication mechanism succeeds and where it\n  fails separately. If the de-duplication mechanism succeeds, the\n  add-(pre-)chain operation is read-only but the old SCT must be\n  reconstructed. If the de-duplication mechanism succeeds, the add-(pre-)chain\n  operation must block until the submitted data is persisted to disk.")]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("Cryptographic Validation.")]),_vm._v(" No information about\n  cryptographic validation is propagated to the monitor's UI, but it is done.\n  We validate that STHs are issued frequently enough, and that the hash in\n  each STH corresponds to the hash of the leaves we've crawled. We also store\n  all SCTs returned from a log's add-chain/add-pre-chain endpoints until we\n  can verify that the log honored the SCT within its maximum merge delay.")]),_vm._v(" "),_c('h6',[_vm._v("Contact")]),_vm._v(" "),_c('p',[_vm._v("Feel free to contact us at "),_c('a',{attrs:{"href":"mailto:ct-logs@cloudflare.com"}},[_vm._v("ct-logs@cloudflare.com")]),_vm._v(".")])]),_c('div',{staticClass:"col-md-2"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "vwga":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-9"},[_c('div',{staticClass:"container"},_vm._l((_vm.organizations),function(org){return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-2 utilization-name"},[_c('h6',{staticClass:"sub-header"},[_vm._v(_vm._s(org.name))])]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('CompGraph',{attrs:{"id":org.name.replace(/[^a-zA-Z0-9]/g, ''),"data":org.data,"palette":_vm.palette,"unit":"pre-certs"}})],1)])}),0)]),_vm._v(" "),_c('div',{staticClass:"col-lg-3"},[_c('ul',{staticClass:"legend list-unstyled"},_vm._l((_vm.logs),function(log){return _c('li',[_c('span',[_c('svg',{staticClass:"legend-swatch"},[_c('rect',{attrs:{"width":"100%","height":"100%","fill":_vm.palette(log.name)}})]),_vm._v("\n          "+_vm._s(log.name))]),_c('br'),_vm._v(" "),_c('span',{staticClass:"legend-label"},[_vm._v(_vm._s(log.count.toLocaleString())+" pre-certs")])])}),0)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "x9ei":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CompGraph_vue__ = __webpack_require__("jnhO");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0058510f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CompGraph_vue__ = __webpack_require__("aOIe");
function injectStyle (ssrContext) {
  __webpack_require__("BlLf")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0058510f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CompGraph_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0058510f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CompGraph_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_widgets_Navbar__ = __webpack_require__("X44g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_widgets_Footbar__ = __webpack_require__("IbL6");
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  components: { Navbar: __WEBPACK_IMPORTED_MODULE_0__components_widgets_Navbar__["a" /* default */], Footbar: __WEBPACK_IMPORTED_MODULE_1__components_widgets_Footbar__["a" /* default */] }
});

/***/ }),

/***/ "zJhq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Errorpage_vue__ = __webpack_require__("pC6E");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f4cf469_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Errorpage_vue__ = __webpack_require__("QcKy");
function injectStyle (ssrContext) {
  __webpack_require__("GNZh")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3f4cf469"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Errorpage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f4cf469_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Errorpage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "zjwr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Logpage_vue__ = __webpack_require__("h75S");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02f19c62_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Logpage_vue__ = __webpack_require__("4ZOf");
function injectStyle (ssrContext) {
  __webpack_require__("+DEH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-02f19c62"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Logpage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02f19c62_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Logpage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.65f06089931403cf7b19.js